






































import BaseComponent from "@/asdcom/BaseComponent"
import { Component, Vue, Inject, Prop, Emit } from "vue-property-decorator";
import { Asdcom } from "@/asdcom/appservice.asdcom";
import { ISendEmailActivationLinkInput, SendEmailActivationLinkInput } from "@/asdcom/apiproxy/apiproxy.dto";

@Component
export default class EmailActivation extends BaseComponent {
  accountService = new Asdcom.AccountAppService();

  @Prop({ type: String, default: "" }) emailActivationText: any;
  emailModel: SendEmailActivationLinkInput = new SendEmailActivationLinkInput();

  public back(): void {
    this.emailModel = new SendEmailActivationLinkInput();
    this.$router.push("/");
  }

  async submit() {
    this.ValidateAll().then(async (isValid: boolean) => {
      if (isValid) {
        // this.$store.dispatch({
        //     type: 'asdcom/public-user/account/sendEmailActivationLinkDispatch',
        //     data: this.emailModel
        // });

        this.accountService.sendEmailActivationLink(this.emailModel);
        sweetAlert({
          title: this.L("EmailVerification"),
          text: this.L("SendEmailVerificationLinkInfo"),
          icon: "info"
        });
        this.back();
      }
    });
  }
}
